/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  class FAQFilteringHandler {
    constructor() {
      (this.faqSections = [...document.querySelectorAll("[data-faq-heading]")]),
        (this.accordions = [
          ...document.querySelectorAll("[data-faq-content]"),
        ]),
        this.faqSections.length && this._init();
    }
    _init() {
      this._setInitialState();

      this.faqSections.forEach((e) => {
        const t = e.getAttribute("data-faq-heading");
        e.addEventListener("click", () => {
          this._hideAccordions();
          this._showAccordions(t);
        });
      });
    }
    _setInitialState() {
      const e = this.faqSections[0].getAttribute("data-faq-heading");
      this._showAccordions(e);
    }
    _showAccordions(e) {
      [...document.querySelectorAll(`[data-faq-content="${e}"]`)].forEach(
        (e) => {
          e.classList.remove("hidden");
        }
      );
    }
    _hideAccordions() {
      this.accordions.forEach((e) => {
        e.classList.add("hidden");
      });
    }
  }

  const sizeGuideListHandler = {
    modal: document.getElementById("sizeGuideModal"),
    modalBtns: [...document.querySelectorAll(".size-guide-modal-btn")],
    modalBtn: document.getElementById("sizeGuideModalBtn"),
    closeBtn: document.getElementById("guide-list__close"),
    init() {
      if (this.modalBtns.length && this.modal) {
        const closeElements = [this.modal, this.closeBtn];

        this.modalBtns.forEach((btn) => {
          btn.onclick = (e) => {
            console.log(btn);
            this.modal.style.display = "flex";
            document.body.style.overflow = "hidden";
          };
        });

        closeElements.forEach((element) => {
          element.onclick = (e) => {
            this.modal.style.display = "none";
            document.body.style.overflow = "";
          };
        });
      }
    },
  };

  function dominantColorLazyLoading() {
    var lazyloadImages;

    if ("IntersectionObserver" in window) {
      lazyloadImages = document.querySelectorAll(".lazy");
      var imageObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var image = entry.target;
            image.src = image.dataset.src;
            image.classList.remove("lazy");
            imageObserver.unobserve(image);
          }
        });
      });

      lazyloadImages.forEach(function (image) {
        imageObserver.observe(image);
      });
    } else {
      var lazyloadThrottleTimeout;
      lazyloadImages = document.querySelectorAll(".lazy");

      function lazyload() {
        if (lazyloadThrottleTimeout) {
          clearTimeout(lazyloadThrottleTimeout);
        }

        lazyloadThrottleTimeout = setTimeout(function () {
          var scrollTop = window.pageYOffset;
          lazyloadImages.forEach(function (img) {
            if (img.offsetTop < window.innerHeight + scrollTop) {
              img.src = img.dataset.src;
              img.classList.remove("lazy");
            }
          });
          if (lazyloadImages.length == 0) {
            document.removeEventListener("scroll", lazyload);
            window.removeEventListener("resize", lazyload);
            window.removeEventListener("orientationChange", lazyload);
          }
        }, 20);
      }

      document.addEventListener("scroll", lazyload);
      window.addEventListener("resize", lazyload);
      window.addEventListener("orientationChange", lazyload);
    }
  }

  // const checkoutCheckbox = {
  //   checkbox: document.getElementById("agreeCheckout"),
  //   button: document.getElementById("checkoutSubmitBtn"),
  //   init() {
  //     if (this.checkbox && this.button) {
  //       console.log(this.checkbox);
  //       console.log(this.button);
  //       this.checkbox.addEventListener("change", () => {
  //         this.button.disabled = !this.checkbox.checked;
  //       });
  //     }
  //   },
  // };

  const externalLinkHandler = {
    links: [...document.querySelectorAll("a")],
    init() {
      this.links.forEach((link) => {
        if (link.host !== window.location.hostname) {
          link.setAttribute("target", "_blank");
          link.setAttribute("rel", "noreferrer noopener");
        }
      });
    },
  };

  const blogSearch = {
    showSearchBtn: document.getElementById("show-blog-search"),
    searchForm: document.getElementById("blog-search-form"),
    init() {
      if (this.showSearchBtn && this.searchForm) {
        console.log(this.showSearchBtn);
        console.log(this.searchForm);

        this.showSearchBtn.addEventListener("click", () => {
          console.log("Search was clicked");
          this.searchForm.style.display = "block";
          this.showSearchBtn.style.display = "none";
        });
      }
    },
  };

  const customMediaSwiper = {
    swiperClass: ".custom-media-swiper",
    init() {
      const element = document.querySelector(this.swiperClass);
      if (element) {
        const slideTitles = [...document.querySelectorAll(".swiper-slide")].map(
          (slide) => slide.dataset.title
        );
        const swiper = new Swiper(this.swiperClass, {
          loop: true,
          effect: "fade",
          crossFade: true,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
              return (
                '<span class="' +
                className +
                '">' +
                slideTitles[index] +
                "</span>"
              );
            },
          },
        });
      }
    },
  };

   (function(){
    var openers = document.querySelectorAll('[data-nlx-open]');
    var body = document.documentElement;

    function openModal(id){
      var modal = document.getElementById(id);
      if(!modal) return;
      modal.hidden = false;
      body.classList.add('nlx-open');
      var btn = document.querySelector('[data-nlx-open="'+id+'"]');
      if(btn) btn.setAttribute('aria-expanded','true');
      // focus first focusable
      var first = modal.querySelector('input, button, [href], select, textarea, [tabindex]:not([tabindex="-1"])');
      if(first) first.focus();
      // esc handler
      function onEsc(e){
        if(e.key === 'Escape'){ closeModal(modal.id); }
      }
      modal._esc = onEsc;
      document.addEventListener('keydown', onEsc);
    }

    function closeModal(id){
      var modal = document.getElementById(id);
      if(!modal) return;
      modal.hidden = true;
      body.classList.remove('nlx-open');
      var btn = document.querySelector('[data-nlx-open="'+id+'"]');
      if(btn) btn.setAttribute('aria-expanded','false');
      if(modal._esc){ document.removeEventListener('keydown', modal._esc); modal._esc = null; }
    }

    openers.forEach(function(btn){
      btn.addEventListener('click', function(){
        openModal(btn.getAttribute('data-nlx-open'));
      });
    });

    document.addEventListener('click', function(e){
      var close = e.target.closest('[data-nlx-close]');
      if(close){
        var modal = close.closest('.nlx');
        if(modal) closeModal(modal.id);
      }
    });
  })();

  document.addEventListener("DOMContentLoaded", () => {
    new FAQFilteringHandler();
    customMediaSwiper.init();
    sizeGuideListHandler.init();
    externalLinkHandler.init();
    blogSearch.init();
    dominantColorLazyLoading();

  });

  //attentive modal 
  function initLinkModalHandlers(root = document) {
    const modal = document.getElementById('link-modal');
    const iframe = document.getElementById('modal-iframe');
    if (!modal || !iframe) return; // modal HTML not on this page

    const closeBtn = modal.querySelector('.modal-close');

    function openModal(url) {
      if (!url) return;
      iframe.src = url;
      modal.classList.add('active');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.remove('active');
      modal.setAttribute('aria-hidden', 'true');
      iframe.src = '';
      document.body.style.overflow = '';
    }

    function onClick(e) {
      const trigger = e.target.closest('[data-open-modal]');
      if (!trigger) return;
      e.preventDefault();
      openModal(trigger.getAttribute('data-modal-url'));
    }

    if (!modal._modalBound) {
      document.addEventListener('click', onClick);
      if (closeBtn) closeBtn.addEventListener('click', closeModal);
      modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });
      modal._modalBound = true;
    }
  }

    // Initial load
    document.addEventListener('DOMContentLoaded', function () {
      initLinkModalHandlers();
    });

    // Re-bind in Theme Editor when a section (like footer) re-renders
    document.addEventListener('shopify:section:load', function () {
      initLinkModalHandlers();
    });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
